/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendLeasingContractVariantDto } from '../../models/backend-leasing-contract-variant-dto';

export interface FinancingSourcesLeasingsVariantsList$Params {
  capex_variant?: number;
  create_date?: string;
  is_blocked?: boolean;

  /**
   * Which field to use when ordering the results.
   */
  ordering?: string;
  project?: number;

  /**
   * A search term.
   */
  search?: string;
  variant_name?: string;
}

export function financingSourcesLeasingsVariantsList(
  http: HttpClient,
  rootUrl: string,
  params?: FinancingSourcesLeasingsVariantsList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<Array<BackendLeasingContractVariantDto>>> {
  const rb = new RequestBuilder(rootUrl, financingSourcesLeasingsVariantsList.PATH, 'get');
  if (params) {
    rb.query('capex_variant', params.capex_variant, {});
    rb.query('create_date', params.create_date, {});
    rb.query('is_blocked', params.is_blocked, {});
    rb.query('ordering', params.ordering, {});
    rb.query('project', params.project, {});
    rb.query('search', params.search, {});
    rb.query('variant_name', params.variant_name, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<Array<BackendLeasingContractVariantDto>>;
    }),
  );
}

financingSourcesLeasingsVariantsList.PATH = '/api/financing_sources/leasings_variants/';
